// Mirrors the backend StudioEnvironment value object (Qualiopi indicator 17,
// "environnement mis à disposition"). Keep in sync with
// academy-context/shared/domain/types/studio-environment.ts on the backend.

export enum VENUE_TYPE {
  PERSONAL_STUDIO = "personal_studio",
  RENTAL_STUDIO = "rental_studio",
}

export enum COACHING_TYPE {
  VOICE = "voice",
  DANCE = "dance",
  INSTRUMENT = "instrument",
  ARTIST_WELLBEING = "artist_wellbeing",
}

export enum SURFACE_AREA {
  UNDER_10 = "under_10",
  FROM_10_TO_20 = "from_10_to_20",
  OVER_20 = "over_20",
}

export enum LIGHTING {
  NATURAL = "natural",
  ARTIFICIAL = "artificial",
}

export enum RECEPTION_CAPACITY_TYPE {
  INDIVIDUAL = "individual",
  MASTERCLASS = "masterclass",
}

export interface ReceptionCapacity {
  type: RECEPTION_CAPACITY_TYPE;
  // Free positive integer when type is MASTERCLASS, null when INDIVIDUAL.
  maxPeople: number | null;
}

export interface MaterialConditions {
  surfaceArea: SURFACE_AREA;
  lighting: LIGHTING;
  hasVentilation: boolean;
  hasHeating: boolean;
  hasWaterAndSanitary: boolean;
  hasSoundproofing: boolean;
}

export interface SafetyConditions {
  hasSmokeDetector: boolean;
  hasFireExtinguisher: boolean;
}

export interface StudioEnvironment {
  // External URL of the studio (website / online booking link), always optional.
  externalUrl: string | null;
  venueType: VENUE_TYPE;
  coachingTypes: COACHING_TYPE[];
  receptionCapacity: ReceptionCapacity;
  materialConditions: MaterialConditions;
  safetyConditions: SafetyConditions;
  // Trainer's honor attestation that the studio can host the teaching in correct
  // safety and hygiene conditions.
  hasHostingHonorAttestation: boolean;
}
